// Get the modal
var modal = document.getElementById("modalCalculator");

// Get the button that opens the modal
var btn = document.getElementById("btnModalTrigger");

// Get the <span> element that closes the modal
var span = document.getElementsByClassName("close")[0];

// When the user clicks on the button, open the modal
btn.onclick = function () {
  modal.style.display = "block";
};

// When the user clicks on <span> (x), close the modal
span.onclick = function () {
  modal.style.display = "none";
  document.getElementById("modalFooter").classList.remove("show");
};


// Get the modal
var modalMoreInfo = document.getElementById("modalMoreInfo");

// Get the button that opens the modal
var btnMoreInfo = document.getElementById("moreInfo");

// Get the <span> element that closes the modal
var spanMoreInfo = document.getElementsByClassName("closeMoreInfo")[0];

// When the user clicks on the button, open the modal
btnMoreInfo.onclick = function () {
  document.getElementById("modalFooter").classList.remove("show");
  modalMoreInfo.style.display = "block";
};

// When the user clicks on <span> (x), close the modal
spanMoreInfo.onclick = function () {
  document.getElementById('resultMessage').style.display = "none";
  modalMoreInfo.style.display = "none";
};

/* 
Math.trunc is not supported in IE as MDN states
*/

if (!Math.trunc) {
  Math.trunc = function (v) {
      return v < 0 ? Math.ceil(v) : Math.floor(v);
  };
}



function doMath() {
  window.location.hash='';
  var inputEmployeeCostHour = document.getElementById("inputEmployeeCostHour")
    .value; //b6
  var inputLaserValue = document.getElementById("inputLaserValue").value; //b7
  var inputSteelSlatCutTime = document.getElementById("inputSteelSlatCutTime")
    .value; //b8
  var inputLaserTimeToChangeSlats = document.getElementById(
    "inputLaserTimeToChangeSlats"
  ).value; //b9
  var inputManHoursToChangeSlats = document.getElementById(
    "inputManHoursToChangeSlats"
  ).value; //b10
  var inputSteelMaterialCost = document.getElementById("inputSteelMaterialCost")
    .value; // b13
  var inputCopperMaterialCost = document.getElementById(
    "inputCopperMaterialCost"
  ).value; //c13
  var inputSteelSlatLifeMonths = document.getElementById("inputSteelSlatLife")
    .value; //b14
  var steelScrapValue = 1 / 100; // b14
  var inputCooperSlatMonths = document.getElementById("inputCooperSlatLife")
  .value;
  //steel
  var steelScrapValuePerYear =
    (inputSteelMaterialCost * steelScrapValue * 12) / inputSteelSlatLifeMonths; //b16
  var steelLaserLostTimePerYear =
    (inputSteelSlatCutTime * inputLaserTimeToChangeSlats * 12) /
    inputSteelSlatLifeMonths; //b17
  var steelLaserLostValuePerYear = inputLaserValue * steelLaserLostTimePerYear; //b18
  var steelEmployeeTimePerYear =
    ((parseInt(inputManHoursToChangeSlats) + parseInt(inputSteelSlatCutTime)) *
      12) /
    inputSteelSlatLifeMonths; //b19
  var steelEmployeeCostPerYear =
    inputEmployeeCostHour * steelEmployeeTimePerYear; //b20
  var steelNetCostPerYear =
    (inputSteelMaterialCost * 12) / inputSteelSlatLifeMonths +
    steelLaserLostValuePerYear +
    steelEmployeeCostPerYear -
    steelScrapValuePerYear; //b21 =B13*12/B14+B18+B20-B16

  //Copper
  var copperSteelSlatLife = inputSteelSlatLifeMonths * 7; //c14
  
  var copperScrapValue = 22 / 100; //c15

  //c16 =C13*C15*12/C14
  var copperScrapValuePerYear = Math.round(
    (inputCopperMaterialCost * copperScrapValue * 12) / copperSteelSlatLife
  );

  //c17 = $B9*12/C14
  var copperLaserLostTimePerYear =
    (inputLaserTimeToChangeSlats * 12) / copperSteelSlatLife;

  //c18 =C17*$B7
  var copperLaserLostValuePerYear = Math.round(
    copperLaserLostTimePerYear * inputLaserValue
  );

  //c19 =($B10)*12/C14
  var copperEmployeeTimePerYear =
    (inputManHoursToChangeSlats * 12) / copperSteelSlatLife;

  //C20 = C19*$B6
  var copperEmployeeCostPerYear = Math.round(
    copperEmployeeTimePerYear * inputEmployeeCostHour
  );

  //C21 =C13*12/C14+C18+C20-C16
  var copperNetCostPerYear = Math.trunc(
    (inputCopperMaterialCost * 12) / copperSteelSlatLife +
      copperLaserLostValuePerYear +
      copperEmployeeCostPerYear -
      copperScrapValuePerYear
  );

  var mathResult = Math.round((steelNetCostPerYear - copperNetCostPerYear)* 100) / 100;

  document.getElementById("result").innerHTML = "";
  
  
  
  if (isNaN(mathResult) || mathResult < 0) {
    document.getElementById("error-message").classList.add("show-error");
    document.getElementById("moreInfo").style.pointerEvents = "none";
    document.getElementById("modalFooter").classList.remove("show");
  } else {
    document.getElementById("error-message").classList.remove("show-error");
    document.getElementById("result").value = "$" + mathResult;
    document.getElementById("moreInfo").style.pointerEvents = "auto";
    document.getElementById("resultForEmail").value = "$" + mathResult;
    window.location.hash='resultClick';
    document.getElementById("modalFooter").classList.add("show");

    //calculation for more info modal
    var spanLaserProductivity = steelLaserLostTimePerYear - copperLaserLostTimePerYear;
    var spanLaserInvoicing =  steelLaserLostValuePerYear - copperLaserLostValuePerYear;
    var spanEmployeeAvailability = steelEmployeeTimePerYear - copperEmployeeTimePerYear;
    var spanEmployeeCostPerYear = steelEmployeeCostPerYear - copperEmployeeCostPerYear;

    document.getElementById("spanLaserProductivity").innerHTML = spanLaserProductivity.toFixed(1);
    document.getElementById("spanLaserInvoicing").innerHTML = spanLaserInvoicing;
    document.getElementById("spanEmployeeAvailability").innerHTML = spanEmployeeAvailability.toFixed(1);
    document.getElementById("spanEmployeeCostPerYear").innerHTML = spanEmployeeCostPerYear.toFixed(1);

    //hiden elements
    document.getElementById("hiddenEmployeeCostHour").value = inputEmployeeCostHour;
    document.getElementById("hiddenLaserValue").value = inputLaserValue;
    document.getElementById("hiddenSteelSlatCutTime").value = inputSteelSlatCutTime;
    document.getElementById("hiddenManHoursToChangeSlats").value = inputManHoursToChangeSlats;
    document.getElementById("hiddenLaserTimeToChangeSlats").value = inputLaserTimeToChangeSlats;
    document.getElementById("hiddenSteelMaterialCost").value = inputSteelMaterialCost;
    document.getElementById("hiddenCopperMaterialCost").value = inputCopperMaterialCost;
    document.getElementById("hiddenSteelSlatLife").value = inputSteelSlatLifeMonths;
    document.getElementById("hiddenCooperSlatLife").value = inputCooperSlatMonths;

    document.getElementById("hiddenLaserProductivity").value = spanLaserProductivity.toFixed(1);
    document.getElementById("hiddenLaserInvoicing").value = spanLaserInvoicing;
    document.getElementById("hiddenEmployeeAvailability").value = spanEmployeeAvailability.toFixed(1);
    document.getElementById("hiddenEmployeeCostPerYear").value = spanEmployeeCostPerYear.toFixed(1);

  }
}

function onlyNumber(id) {
  var DataVal = document.getElementById(id).value;
  document.getElementById(id).value = DataVal.replace(/[^0-9]/g, "");
}
function multiplyNumber(id) {
  var DataVal = document.getElementById(id).value;
  document.getElementById('inputCooperSlatLife').value = DataVal * 7;
}
function sendResults() {
    var email = document.getElementById('resultEmail').value.trim();
    var result = document.getElementById('resultForEmail').value.substr(1);
    var hiddenEmployeeCostHour =  document.getElementById('hiddenEmployeeCostHour').value;
    var hiddenLaserValue =  document.getElementById('hiddenLaserValue').value;
    var hiddenSteelSlatCutTime =  document.getElementById('hiddenSteelSlatCutTime').value;
    var hiddenLaserTimeToChangeSlats =  document.getElementById('hiddenLaserTimeToChangeSlats').value;
    var hiddenManHoursToChangeSlats =  document.getElementById('hiddenManHoursToChangeSlats').value;
    var hiddenSteelMaterialCost =  document.getElementById('hiddenSteelMaterialCost').value;
    var hiddenCopperMaterialCost =  document.getElementById('hiddenCopperMaterialCost').value;
    var hiddenSteelSlatLife =  document.getElementById('hiddenSteelSlatLife').value;
    var hiddenCooperSlatLife =  document.getElementById('hiddenCooperSlatLife').value;
    var hiddenLaserProductivity =  document.getElementById('hiddenLaserProductivity').value;
    var hiddenLaserInvoicing =  document.getElementById('hiddenLaserInvoicing').value;
    var hiddenEmployeeAvailability =  document.getElementById('hiddenEmployeeAvailability').value;
    var hiddenEmployeeCostPerYear =  document.getElementById('hiddenEmployeeCostPerYear').value;

    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function() {
        if (xhttp.readyState == XMLHttpRequest.DONE) {
            document.getElementById('resultMessage').innerHTML = xhttp.responseText;
            document.getElementById('resultMessage').style.display = "block";
        }
    }    
    xhttp.open("POST", "https://slats.slatpro.com/mail.php", true);
    xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    xhttp.send("resultEmail="+email+"&resultForEmail="+result+"&hiddenEmployeeCostHour="+hiddenEmployeeCostHour
            +"&hiddenLaserValue="+hiddenLaserValue+"&hiddenSteelSlatCutTime="+hiddenSteelSlatCutTime
            +"&hiddenLaserTimeToChangeSlats="+hiddenLaserTimeToChangeSlats+"&hiddenManHoursToChangeSlats="+hiddenManHoursToChangeSlats
            +"&hiddenSteelMaterialCost="+hiddenSteelMaterialCost+"&hiddenCopperMaterialCost="+hiddenCopperMaterialCost
            +"&hiddenSteelSlatLife="+hiddenSteelSlatLife+"&hiddenLaserProductivity="+hiddenLaserProductivity
            +"&hiddenLaserInvoicing="+hiddenLaserInvoicing+"&hiddenEmployeeAvailability="+hiddenEmployeeAvailability
            +"&hiddenEmployeeCostPerYear="+hiddenEmployeeCostPerYear
            +"&hiddenCooperSlatLife="+hiddenCooperSlatLife);
}
